import { Inject, Injectable } from '@angular/core';
import {
  AbstractNavigationService,
  KEEPS_NAVIGATION_ITEMS,
  KeepsNavigationItem,
} from '@keeps-platform-frontend-workspace/layout';
import { UserProfileService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { filter } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class NavigationService extends AbstractNavigationService {
  private userRoles: string[];

  constructor(
    @Inject(KEEPS_NAVIGATION_ITEMS) navigationItems: KeepsNavigationItem[],
    private userProfileService: UserProfileService,
    private keycloakService: KeycloakService,
  ) {
    super(navigationItems);
    this.checkNavigationAfterUserLogin();
  }

  override getHiddenItemsIds(): string[] {
    return this.getHiddenItensIdsByRole(this.userRoles);
  }

  private checkNavigationAfterUserLogin() {
    this.userProfileService.roles$.pipe(filter((roles) => !!roles.length)).subscribe(() => {
      const userRoles = this.userProfileService.getApplicationRoles();
      const canManageUsers = this.keycloakService.getUserRoles().includes('manage-users');
      if (canManageUsers) {
        userRoles.push('manage-users');
      }
      this.userRoles = userRoles;
      this.updateAllItemsVisibility();
    });
  }
}
